import { render } from "./PublicSearchPage.vue?vue&type=template&id=c00f8c64&scoped=true&ts=true"
import script from "./PublicSearchPage.vue?vue&type=script&lang=ts"
export * from "./PublicSearchPage.vue?vue&type=script&lang=ts"

import "./PublicSearchPage.vue?vue&type=style&index=0&id=c00f8c64&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c00f8c64"]])

export default __exports__